import type { ReactNode } from "react";
import type { CustomApp } from "@clickdialog/product-registry";
import type { PlatformApiClient } from "./api";
import { Mesa28AdminV2 } from "./Mesa28AdminV2";
import type { OrganizationContext } from "./types";

export interface CustomAppRuntimeProps {
  organization: OrganizationContext;
  app: CustomApp;
  api: PlatformApiClient;
  onAppChange: (app: CustomApp) => void;
}

interface CustomAppRuntimeDefinition {
  appKey: string;
  icon: string;
  render: (props: CustomAppRuntimeProps) => ReactNode;
}

const CUSTOM_APP_RUNTIMES: readonly CustomAppRuntimeDefinition[] = Object.freeze([
  Object.freeze({
    appKey: "mesa-28",
    icon: "28",
    render: (props: CustomAppRuntimeProps) => (
      <Mesa28AdminV2
        organization={props.organization}
        app={props.app}
        api={props.api}
        onAppChange={props.onAppChange}
      />
    ),
  }),
]);

const runtimeByAppKey = new Map(
  CUSTOM_APP_RUNTIMES.map((runtime) => [runtime.appKey, runtime] as const),
);

export function renderCustomAppRuntime(
  app: CustomApp,
  props: Omit<CustomAppRuntimeProps, "app">,
): ReactNode | null {
  const runtime = runtimeByAppKey.get(app.appKey);
  return runtime?.render({ ...props, app }) ?? null;
}

export function customAppIcon(appKey: string): string {
  return runtimeByAppKey.get(appKey)?.icon ?? "C";
}
